import { useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { noPropagateDialog$ } from "src/framework/store/ApiEvents"
import { LoginStore } from "src/framework/store/LoginStore"

export function SignoutPage(){
  const location = useLocation()
  const history = useHistory()
  
  useEffect(()=>{
    const uri = window.location.origin.endsWith("/") ? window.location.origin : `${window.location.origin}/`
    noPropagateDialog$.next(true)
    LoginStore.doLogOut()
    LoginStore.getContaUrlCompleto(uri).then(contaUrl => {
      if (contaUrl) window.location.href = contaUrl
    })
  },[history, location, location.search])


  return (
    <span>Saindo...</span>
  )
}